import React from "react";
import { NavLink } from "react-router-dom";
import {
	FolioHome,
	FolioIngenio,
	FolioSearch,
	FolioCabin,
	FolioResume,
	FolioAbout,
} from "./AppContent";
import IconFaLinkedin from "../img/IconFaLinkedin";
import IconFaMobile from "../img/IconFaMobile";
import IconFaEmail from "../img/IconFaEmail";

function AppFooter(props) {
	return (
		<footer className="app-footer">
			<nav className="footer-nav">
				<ul className="footer-nav-list">
					<li>
						<NavLink exact to={FolioHome.path} activeClassName="selected">
							<span className="project">{FolioHome.linkName}</span>
						</NavLink>
					</li>
					<li>
						<NavLink exact to={FolioIngenio.path} activeClassName="selected">
							<span className="project">{FolioIngenio.caseStudy}</span>
						</NavLink>
					</li>
					<li>
						<NavLink exact to={FolioSearch.path} activeClassName="selected">
							<span className="project">{FolioSearch.caseStudy}</span>
						</NavLink>
					</li>
					<li>
						<NavLink exact to={FolioCabin.path} activeClassName="selected">
							<span className="project">{FolioCabin.caseStudy}</span>
						</NavLink>
					</li>
					<li>
						<NavLink exact to={FolioAbout.path} activeClassName="selected">
							<span className="project">{FolioAbout.linkName}</span>
						</NavLink>
					</li>
					<li>
						<NavLink exact to={FolioResume.path} activeClassName="selected">
							<span className="project">{FolioResume.linkName}</span>
						</NavLink>
					</li>
				</ul>
			</nav>
			<ul className="footer-contacts">
				<li>
					<IconFaEmail /> info@••••.com
				</li>
				<li>
					<IconFaMobile /> (404) ••• ••••
				</li>
				<li>
					<a
						href="https://www.linkedin.com/in/martinduggan"
						target="_blank"
						rel="noopener noreferrer"
					>
						<IconFaLinkedin />
						Linkedin
					</a>
				</li>
			</ul>
			{/* <button onClick={() => props.handleScroll()} class="btn-top">
        Top
      </button> */}
		</footer>
	);
}

export default AppFooter;
